import React from "react";
import { Helmet } from "react-helmet-async";
import { useNavigate } from "react-router-dom";
import {
  MdChevronRight,
  MdHistory,
  MdLocationOn,
  MdAccountBalanceWallet,
  MdPlaylistAdd,
  MdFavorite,
} from "react-icons/md";

import styles from "./Profile.module.scss";
import { useProfile } from "./useProfile";
import { PageHeader } from "../../common/components/pageHeader/PageHeader";
import { EmptyState } from "../../common/components/emptyState/EmptyState";
import { getApi } from "../../api/api";
import {
  ORDERS_ROUTE,
  ADDRESSES_ROUTE,
  BONUSES_ROUTE,
  COMPLEX_ORDERS_ROUTE,
  FAVORITES_ROUTE,
} from "../../common/utils/constants";

const MENU_ITEMS = [
  { icon: MdHistory, title: "История заказов", route: ORDERS_ROUTE },
  { icon: MdLocationOn, title: "Мои адреса", route: ADDRESSES_ROUTE },
  { icon: MdAccountBalanceWallet, title: "Бонусы", route: BONUSES_ROUTE },
  { icon: MdPlaylistAdd, title: "Мои проекты", route: COMPLEX_ORDERS_ROUTE },
  { icon: MdFavorite, title: "Избранное", route: FAVORITES_ROUTE },
];

export const Profile: React.FC = () => {
  const navigate = useNavigate();
  const { displayName, myClusters, ready, isEmpty } = useProfile();

  if (!ready) return null;

  return (
    <div className={styles.Page}>
      <Helmet>
        <title>Профиль — ЛОГМОЛЛ</title>
      </Helmet>

      <PageHeader title="Профиль" />

      <div className={styles.Content}>
        <div className={styles.ProfileHero}>
          <span className={styles.EmailBg} aria-hidden="true">
            {displayName}
          </span>
          <span className={styles.EmailLabel}>{displayName}</span>
        </div>

        {isEmpty ? (
          <EmptyState
            icon={MdHistory}
            title="Пока нет компаний"
            description="Сделайте первый заказ в каталоге, чтобы здесь появились ваши компании."
          />
        ) : (
          <>
            <div className={styles.Section}>
              <h2 className={styles.SectionTitle}>компании</h2>
              <div className={styles.ClustersGrid}>
                {myClusters.map((c) => (
                  <button
                    key={c.id}
                    type="button"
                    className={styles.ClusterCard}
                    onClick={() =>
                      navigate(`${ORDERS_ROUTE}?clusterId=${c.id}`)
                    }
                  >
                    <img
                      src={`https://${c.domain}/icons/logo512.png`}
                      alt={c.name}
                      className={styles.ClusterLogo}
                    />
                    <span className={styles.ClusterName}>{c.name}</span>
                  </button>
                ))}
              </div>
            </div>

            <div className={styles.Section}>
              <h2 className={styles.SectionTitle}>Разделы</h2>
              <div className={styles.Menu}>
                {MENU_ITEMS.map((item) => (
                  <button
                    key={item.route}
                    type="button"
                    className={styles.MenuItem}
                    onClick={() => navigate(item.route)}
                  >
                    <item.icon size={24} className={styles.MenuIcon} />
                    <span className={styles.MenuText}>{item.title}</span>
                    <MdChevronRight size={22} className={styles.MenuArrow} />
                  </button>
                ))}
              </div>
            </div>
          </>
        )}

        <button
          type="button"
          className={styles.LogoutLink}
          onClick={() => getApi().logout()}
        >
          Выйти
        </button>
      </div>
    </div>
  );
};
